import validateWhitelabel from 'lane-shared/validation/validateWhitelabel';
import { createWhitelabelPrivacyValidator } from 'pages/portal/portal-management/whitelabels/validators/validateWhitelabelPrivacySettings';

export const validateWhitelabelWithPrivacyPolicyTermsConfiguration =
  createWhitelabelPrivacyValidator(validateWhitelabel);
